<section class="vm-tab-section vm-row" [id]="data?.id">
  <h2 *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy"></vm-markdown>
  <vm-selectable-cards    
    [containerItemAlignment]="'space-between'"
    [selectableCards]="data?.items"
    (selectedCards)="onSelectedCard($event)">
  </vm-selectable-cards>
</section>